import React from 'react'
import {Link} from 'react-router'
import {Container, Row, Col, Button, Progress, Table} from 'reactstrap';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';

import Loader from '../../core/components/Loader'
import {renderIconSpecialties} from '../utils'
import {capitalizeFirstLetter} from '../../utils/parse'

import '../styles/style.css';

class ProviderList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            BAU: true,
            MV: true,
            responsive: false
        };

        this.specialtiesFormatter = this.specialtiesFormatter.bind(this)
    }

    componentDidMount() {
        this.props.listProvider(null, this.props.date);
        if (window.innerWidth < 520)
            this.setState({responsive: true})
    }

    onChangeNetwork(net, event) {
        if (net === "BAU")
            this.setState({BAU: !this.state.BAU});
        if (net === "MV")
            this.setState({MV: !this.state.MV})
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextState !== this.state) {
            if (!nextState.MV && nextState.BAU)
                this.props.listProvider("BAU", this.props.date);
            else if (nextState.MV && !nextState.BAU)
                this.props.listProvider("1MV", this.props.date);
            else
                this.props.listProvider(this.props.date)
        }
    }

    companyFormatter(cell, row, enumObject, index) {
        return (
            <div className="company-formatter">
                <Link to={"/manager/prestataire/" + row.id}>
                    <div className="company"> {capitalizeFirstLetter(row.company)} </div>
                </Link>
                <Link to={"/manager/prestataire/" + row.id}>
                    <div
                        className="name"> {capitalizeFirstLetter(row.first_name)} {capitalizeFirstLetter(row.last_name)} </div>
                </Link>
            </div>
        );
    }

    regionFormatter(cell, row, enumObject, index) {
        return (
            <div className="region-formatter">
                <div className="region"> {row.region_name} </div>
                <div className="departments"> {row.list_departments.join('-')} </div>
            </div>
        );
    }

    specialtiesFormatter(cell, row, enumObject, index) {
        return (
            <div className="specialties-formatter">
                {renderIconSpecialties(cell)}
            </div>
        );
    }

    renderProviders() {
        const {list_provider} = this.props

        return (
            <div className="table-list-lead">
                {!this.state.responsive &&
                <BootstrapTable ref='table' data={list_provider.list} options={this.options} pagination>
                    <TableHeaderColumn dataField='code_provider' dataSort={true}> Code prestataire </TableHeaderColumn>
                    <TableHeaderColumn dataField='company' isKey={true} dataSort={true}
                                       dataFormat={this.companyFormatter}> Raison sociale </TableHeaderColumn>
                    <TableHeaderColumn dataField='region' dataSort={true}
                                       dataFormat={this.regionFormatter}> Région </TableHeaderColumn>
                    <TableHeaderColumn dataField='phone' dataSort={true}> Téléphone </TableHeaderColumn>
                    <TableHeaderColumn dataField='username' dataSort={true}> Email </TableHeaderColumn>
                    <TableHeaderColumn dataField='specialties' dataFormat={this.specialtiesFormatter}
                                       dataSort={true}> Compétences </TableHeaderColumn>
                </BootstrapTable>
                }
                {this.state.responsive &&
                <BootstrapTable ref='table' data={list_provider.list} options={this.options} pagination>
                    <TableHeaderColumn dataField='company' isKey={true} dataSort={true}
                                       dataFormat={this.companyFormatter}> Raison sociale </TableHeaderColumn>
                </BootstrapTable>
                }
            </div>
        )

    }

    render() {
        const {list_provider} = this.props

        return (
            <div>

                <div className="leads-header">
                    <Row>
                        <Col>
                            <div className="leads-total"> {list_provider.list.length} Prestataires</div>

                            <div className="leads-refusal">
                                <label><input type="checkbox" onChange={(event) => this.onChangeNetwork("BAU", event)}
                                              checked={this.state.BAU}/> Réseau Agréé </label>
                            </div>

                            <div className="leads-refusal">
                                <label><input type="checkbox" checked={this.state.MV}
                                              onChange={(event) => this.onChangeNetwork("MV", event)}/> Réseau
                                    1MV</label>
                            </div>

                        </Col>

                    </Row>
                </div>

                {list_provider.fulfilled &&
                this.renderProviders()
                }

                {list_provider.pending &&
                <Loader/>
                }

            </div>
        )
    }
}


export default ProviderList



// WEBPACK FOOTER //
// ./src/provider/components/ProviderList.js